/**
 * Une ligne de bon de commande déjà liée à une commande ne doit pas redemander
 * la création : le serveur fusionnerait la quantité une deuxième fois.
 */
export function doitCreerCommandeDepuisLigneBonCommande(
    dejaLieeAUneCommande: boolean,
    indAjoutCommande: boolean | undefined
): boolean {
    return !dejaLieeAUneCommande && !!indAjoutCommande;
}
